import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { elStyle } from '@/component/project/NormalViewContract/common/ContractTableHandlerCss';
import { Box, MenuItem, Select, makeStyles } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React from 'react';
import { isDisabledAllFieldCsv } from '../handler/KnowledgeUploadCsvHandler';

export default function DropDownUniqueKey({
    selectedTypeImportCsv,
    selectedOptionKnowledgeId,
    setSelectedOptionKnowledgeId,
    listOptionsKnowledgeId,
    listUniQueField,
    selectedUniQueField, 
    setSelectedUniQueField,
    selectedUniQueCsv, 
    setSelectedUniQueCsv,
    handleStatus
}) {
    const useStyles = makeStyles(theme => ({
        dropdownStyle: {
            maxHeight: '200px',
            overflowY: 'auto'
        }
    }));
    const classes = useStyles();

    const handleChangeSelectedType = e => {
        setSelectedOptionKnowledgeId(e.target.value);
    };

    const handleChangeUniQueField = e => {
        let fieldInfo = listUniQueField.find(field => field.id === e.target.value);
        setSelectedUniQueField({
            key: e.target.value,
            name: Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                fieldInfo.name
            )
        });
    };

    const renderBySelectedType = () => {
        switch (selectedTypeImportCsv) {
            case Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.NO_OVERWRITE:
                return null;
            case Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.KNOWLEDGE_ID:
                return (
                    <div className="pt-16">
                        <div className="options-import-csv">
                            <label className="label-upload-csv">
                                {I18n.get('LABEL-KN-ID-CSV-COLUMN')}
                            </label>
                            <Select
                                fullWidth
                                className="form-control form-control--wrap"
                                select
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                                variant="outlined"
                                value={selectedOptionKnowledgeId}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    classes: { paper: classes.dropdownStyle },
                                    getContentAnchorEl: null
                                }}
                                onChange={handleChangeSelectedType}
                            >
                                {listOptionsKnowledgeId?.map((item, index) => (
                                    <MenuItem
                                        value={item.key}
                                        key={`${item.key}_knowledgeId_${index}`}
                                    >
                                        <OverFlowTooltipWithTabsMui
                                            value={item.value}
                                            className="mapping-item"
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <Box className="warning-icon pt-16 d-flex items-baseline">
                            <img
                                src="/assets/image/icon-listEmpty.svg"
                                alt="icon-warning"
                                style={{ opacity: 0.7, paddingTop: '5px' }}
                            />
                            <Box
                                component="span"
                                className="warning-content"
                                {...elStyle.warning_content}
                            >
                                {I18n.get('MSG-KNOWLEDGE-UNIQUE-KEY-ID')}
                            </Box>
                        </Box>
                    </div>
                );
            case Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_IMPORT_CSV.FIELD_OF_FORM:
                return (
                    <div className="pt-16">
                        <div className="options-import-csv">
                            <label className="label-upload-csv">
                                {I18n.get('LABEL-SETTING-UNIQUE-KEY-FIELD')}
                                <span className="required">*</span>
                            </label>
                            <Select
                                fullWidth
                                className="form-control form-control--wrap"
                                select
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                                variant="outlined"
                                value={selectedUniQueField?.key}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    classes: { paper: classes.dropdownStyle },
                                    getContentAnchorEl: null
                                }}
                                onChange={handleChangeUniQueField}
                            >
                                {listUniQueField?.map((item, index) => (
                                    <MenuItem
                                        value={item.id}
                                        key={`${item.id}_uniQueField_${index}`}
                                    >
                                        <OverFlowTooltipWithTabsMui
                                            value={Utils.getTextByLanguage(
                                                Constant.LANGUAGE_TYPE.JP,
                                                item.name
                                            )}
                                            className="mapping-item"
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                        <div className="options-import-csv pt-16">
                            <label className="label-upload-csv">
                                {I18n.get('LABEL-UNIQUE-KEY-CSV-COLUMN')}
                                <span className="required">*</span>
                            </label>
                            <Select
                                fullWidth
                                className="form-control form-control--wrap"
                                select
                                disabled={isDisabledAllFieldCsv(handleStatus)}
                                variant="outlined"
                                value={selectedUniQueCsv}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null
                                }}
                                onChange={e => setSelectedUniQueCsv(e.target.value)}
                            >
                                {listOptionsKnowledgeId?.map((item, index) => (
                                    <MenuItem
                                        value={item.key}
                                        key={`${item.key}_uniQueCsv_${index}`}
                                    >
                                        <OverFlowTooltipWithTabsMui
                                            value={item.value}
                                            className="mapping-item"
                                        />
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <Box className="warning-icon pt-16 d-flex items-start">
                            <img
                                src="/assets/image/icon-listEmpty.svg"
                                alt="icon-warning"
                                style={{ opacity: 0.7, marginTop: '3px' }}
                            />
                            <Box
                                component="span"
                                className="warning-content"
                                {...elStyle.warning_content}
                            >
                                {I18n.get('MSG-KNOWLEDGE-UNIQUE-KEY-FIELD').replace(
                                    '{{field_name}}',
                                    selectedUniQueField?.name ? selectedUniQueField?.name : ''
                                )}
                            </Box>
                        </Box>
                    </div>
                );
            default:
                return null;
        }
    };
    return renderBySelectedType();
}
